// import { AnniversaryOccasion, User } from "./types";
// import { dummyUsers, messageTemplates } from './data';

// Calculate age from birth date
export const calculateAge = (birthDate: string) => {
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
    }
    return age;
};

// Calculate years since a date
export const calculateYearsSince = (date: string) => {
    const today = new Date();
    const eventDate = new Date(date);
    return today.getFullYear() - eventDate.getFullYear();
};

/*
// Generate parameter values for a user and occasion
const generateParameters = (user: User, occasion: string) => {
    const params: Record<string, string> = {
        name: user.name
    };

    switch (occasion) {
        case 'birthday':
            params.age = calculateAge(user.birthDate).toString();
            break;
        case 'wedding':
            if (user.weddingDate) {
                params.anniversaryYear = calculateYearsSince(user.weddingDate).toString();
            }
            break;
        case 'baptism':
            if (user.baptismDate) {
                params.baptismYears = calculateYearsSince(user.baptismDate.toString()).toString();
            }
            break;
        case 'communion':
            if (user.firstCommunionDate) {
                params.communionYears = calculateYearsSince(user.firstCommunionDate.toString()).toString();
            }
            break;
    }

    return params;
};


// Replace parameters in template content
const replaceParameters = (content: string, parameters: Record<string, string>) => {
    let result = content;
    Object.entries(parameters).forEach(([key, value]) => {
        result = result.replace(new RegExp(`{{${key}}}`, 'g'), value);
    });
    return result;
};

// Check if a user has an occasion on the selected date
const checkUserOccasions = (user: User, date: string) => {
    const occasions: AnniversaryOccasion[] = [];
    const selectedDateObj = new Date(date);
    const selectedMonth = selectedDateObj.getMonth();
    const selectedDay = selectedDateObj.getDate();

    // Check birthday
    const birthDate = new Date(user.birthDate);
    if (birthDate.getMonth() === selectedMonth && birthDate.getDate() === selectedDay) {
        const templates = messageTemplates.filter(t => t.occasion === 'BIRTHDAY');
        const randomTemplate = templates[Math.floor(Math.random() * templates.length)];
        const parameters = generateParameters(user, 'BIRTHDAY');
        const message = replaceParameters(randomTemplate.content, parameters);

        occasions.push({
            id: `${user.id}-birthday`,
            user,
            type: 'birthday',
            // template : '',
            date: user.birthDate,
            years: calculateAge(user.birthDate),
            message
        });
    }

    // Check wedding anniversary
    if (user.weddingDate) {
        const weddingDate = new Date(user.weddingDate);
        if (weddingDate.getMonth() === selectedMonth && weddingDate.getDate() === selectedDay) {
            const templates = messageTemplates.filter(t => t.occasion === 'WEDDING_ANNIVERSARY');
            const randomTemplate = templates[Math.floor(Math.random() * templates.length)];
            const parameters = generateParameters(user, 'WEDDING_ANNIVERSARY');
            const message = replaceParameters(randomTemplate.content, parameters);

            occasions.push({
                id: `${user.id}-wedding`,
                user,
                type: 'wedding',
                date: user.weddingDate,
                years: calculateYearsSince(user.weddingDate),
                message
            });
        }
    }

    // Check baptism anniversary
    if (user.baptismDate) {
        const baptismDate = new Date(user.baptismDate);
        if (baptismDate.getMonth() === selectedMonth && baptismDate.getDate() === selectedDay) {
            const templates = messageTemplates.filter(t => t.occasion === 'BAPTISM_ANNIVERSARY');
            const randomTemplate = templates[Math.floor(Math.random() * templates.length)];
            const parameters = generateParameters(user, 'BAPTISM_ANNIVERSARY');
            const message = replaceParameters(randomTemplate.content, parameters);

            occasions.push({
                id: `${user.id}-baptism`,
                user,
                type: 'baptism',
                date: user.baptismDate,
                years: calculateYearsSince(user.baptismDate),
                message
            });
        }
    }

    // Check communion anniversary
    if (user.firstCommunionDate) {
        const communionDate = new Date(user.firstCommunionDate);
        if (communionDate.getMonth() === selectedMonth && communionDate.getDate() === selectedDay) {
            const templates = messageTemplates.filter(t => t.occasion === 'COMMUNION_ANNIVERSARY');
            const randomTemplate = templates[Math.floor(Math.random() * templates.length)];
            const parameters = generateParameters(user, 'COMMUNION_ANNIVERSARY');
            const message = replaceParameters(randomTemplate.content, parameters);

            occasions.push({
                id: `${user.id}-communion`,
                user,
                type: 'communion',
                date: user.firstCommunionDate,
                years: calculateYearsSince(user.firstCommunionDate),
                message
            });
        }
    }

    return occasions;
};
*/